export default "__VITE_ASSET__C76Hv34M__"